import { createDialogQueue } from "./dialog-queue";

const dialogQueue = createDialogQueue();

export const { DialogQueue } = dialogQueue;
export const { showDialogAsync } = dialogQueue;
